export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RESULT_PER_PAGE = 10;
export const KEY = '';
export const MODAL_CLOSE_SECONDS = 2.5;
